import { watch } from "vue"
import { useListLegalDependents } from "@/composables/legal-dependents"
import { useEnrollmentStore } from "@/modules/enrollment-new/stores/enrollment-new-store"

/**
 * Watches the TanStack Query cache for legal dependents and syncs
 * them into the enrollment store. This is the single directional
 * data flow: Server → Query cache → Store.
 */
export function useEnrollmentDependentsSync(memberId: string) {
  const { legalDependents, isLoading, refetch } = useListLegalDependents(memberId)
  const enrollmentStore = useEnrollmentStore()

  watch(
    [legalDependents, isLoading],
    ([serverDeps, loading]) => {
      if (loading) return
      enrollmentStore.syncDependentsFromServer(serverDeps)
    },
    { immediate: true }
  )

  return { legalDependents, isLoading, refetch }
}
